import { ICloudStorageProviderFactory } from "../../domain/Upload/i-cloud-storage-provider-factory";
import { Injectable } from "@angular/core";
import { HttpService } from "../http/http";
import { UserService } from "../../domain/user-service";
import { Logger } from "../logger";
import { Auth } from "../auth";
import { ICloudStorageProvider } from "../../domain/Upload/i-cloud-storage-provider";
import { S3CloudProvider } from "./s3-cloud-provider";
import { EStorageProvider } from "../../domain/Upload/e-storage-provider";
import { OvhCloudProvider } from "./ovh-cloud-provider";
import { HttpClient } from "@angular/common/http";
import { OracleObjectStorageProvider } from "./oracle-object-storage-provider";

@Injectable()
export class CloudStorageProviderFactory
  implements ICloudStorageProviderFactory
{
  public currentCloudStorageProvider: ICloudStorageProvider;

  createInstance(
    httpService: HttpService,
    userService: UserService,
    logger: Logger,
    auth: Auth,
    httpClient: HttpClient,
  ): ICloudStorageProvider {
    if (this.currentCloudStorageProvider) {
      return this.currentCloudStorageProvider;
    }

    switch (userService.getCurrentUser().fileStorageProvider) {
      case EStorageProvider.OVH:
        this.currentCloudStorageProvider = new OvhCloudProvider(
          httpService,
          httpClient,
          auth,
        );
        break;
      case EStorageProvider.S3:
        this.currentCloudStorageProvider = new S3CloudProvider(
          httpService,
          userService,
          logger,
          auth,
        );
        break;

      case EStorageProvider.Oracle:
        this.currentCloudStorageProvider = new OracleObjectStorageProvider(
          httpService,
          httpClient,
          auth,
        );
        break;
    }
    //this.currentCloudStorageProvider = new OracleObjectStorageProvider(httpService, httpClient, auth);

    return this.currentCloudStorageProvider;
  }

  getCurrent(): ICloudStorageProvider {
    return this.currentCloudStorageProvider;
  }
}
